export enum QuickNavigationItemName {
  Collections = 'collections',
  Dashboards = 'dashboards',
  Databases = 'databases',
  Workspace = 'workspace',
  User = 'user',
  Talk = 'talk',
  Ai = 'ai',
  Favourites = 'favourites',
  DirectChat = 'direct-chat',
  Automations = 'automations',
  MyWork = 'my-work',
  Notifications = 'notifications',
  Avatar = 'avatar',
  Home = 'home',
  Search = 'search',
  Mail = 'mail',
}
